import { ACCESSTOKEN_KEY, REFRESHTOKEN_KEY } from 'configs/api';
import { publicFetch } from 'services/fetch';

let refreshPromise = null;

// Returns a promise that resolves with the new access token string.
// Multiple concurrent callers share the same in-flight request — only one
// POST /access-token is issued regardless of how many 401s arrive at once.
export const getOrStartRefresh = () => {
    if (!refreshPromise) {
        refreshPromise = publicFetch
            .post('/access-token', {
                RefreshToken: localStorage.getItem(REFRESHTOKEN_KEY),
            })
            .then(({ data }) => {
                localStorage.setItem(ACCESSTOKEN_KEY, data.AccessToken);
                return data.AccessToken;
            })
            .finally(() => { refreshPromise = null; });
    }
    return refreshPromise;
};
